// Browser-side Supabase Auth client — used by the Home page login
// form for the post-disconnect login flow.
//
// When VITE_SUPABASE_URL + VITE_SUPABASE_ANON_KEY are set on the
// frontend, the login form signs in directly against Supabase Auth
// (signInWithPassword in the browser) and then exchanges the Supabase
// access token for our app JWT via POST /api/auth/exchange. When the
// env vars are absent, isSupabaseConfigured() returns false and the
// form falls back to the legacy server-side /api/auth/supabase/login
// path unchanged — so clients without the new env vars keep working
// exactly as today.

import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

let client = null;

export function isSupabaseConfigured() {
  return Boolean(SUPABASE_URL && SUPABASE_ANON_KEY);
}

// Lazy singleton — only instantiated when the browser-side login flow
// is actually used, so unconfigured clients never touch supabase-js
// at runtime.
export function getSupabaseClient() {
  if (!isSupabaseConfigured()) {
    throw new Error('Supabase frontend client not configured (VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY)');
  }
  if (!client) {
    client = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
  }
  return client;
}
